import { Helmet } from 'react-helmet-async'
import logoLt from '../../assets/logo-lt.svg'

export const ErrorGlobal = ({ onRetry }: { onRetry?: () => void }) => {
    return (
        <>
            <div className="z-50 fixed px-4 md:px-[6rem] md:py-6">
                <a
                    href="/"
                    className="flex items-center"
                    aria-label="Retour à l'accueil"
                >
                    <img
                        src={logoLt}
                        className="mr-1 h-6 sm:h-9 self-center"
                        alt=""
                    />
                    <span
                        className="self-center text-xl font-semibold whitespace-nowrap text-black"
                        lang="en"
                        translate="no"
                    >
                        Listen too
                    </span>
                </a>
            </div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Listen too | Erreur</title>
                <meta
                    name="description"
                    content="Page d'erreur de Listen too, agence informatique"
                />
            </Helmet>
            <section className="flex items-center h-full p-16">
                <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
                    <div className="max-w-md text-center">
                        <h1 className="mb-8 font-semibold text-9xl">
                            <span className="sr-only">Erreur</span>
                        </h1>
                        <p className="text-2xl font-semibold md:text-3xl">
                            Le site est actuellement indisponible
                        </p>
                        <p className="mt-4 mb-8 ">
                            Veuillez réessayer ultérieurement
                        </p>
                        {onRetry && (
                            <button
                                type="button"
                                onClick={onRetry}
                                className="rounded bg-primary-500 px-6 py-3 font-semibold text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
                            >
                                Réessayer
                            </button>
                        )}
                    </div>
                </div>
            </section>
        </>
    )
}
